module.exports = __webpack_public_path__ + "static/media/mobile-image-background-checker-pattern-1.04f79758.svg";